import { render, staticRenderFns } from "./TosDialog.vue?vue&type=template&id=1e344a6a"
import script from "./TosDialog.vue?vue&type=script&lang=js"
export * from "./TosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports